import axios from "axios";
import config from "../Config/applicationEnv";

export const getBaseUrl = () => config.BASE_URL || "https://apipostman.onlinecu.in/";

const axiosInstance = axios.create({
  baseURL: getBaseUrl(),
});

axiosInstance.interceptors.request.use(
  (reqConfig) => {
    try {
      const slotbook = localStorage.getItem("slotbook");
      const data = slotbook ? JSON.parse(slotbook) : null;
      const token = data?.accessToken;
      if (token) {
        reqConfig.headers.Authorization = `Bearer ${token}`;
      }
    } catch (e) {
      // ignore
    }
    return reqConfig;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Avoid redirect loop if already on the login page
      if (window.location.pathname !== "/login") {
        localStorage.clear();
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
